"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.MaskBarCode = function (value) {
  value = value.replace(/\D/g, '');
  value = value.substring(0, 48);
  if (value.length < 48) {
    value = value.replace(/(\d{33})(\d)/, '$1 $2');
    value = value.replace(/(\d{32})(\d)/, '$1 $2');
    value = value.replace(/(\d{26})(\d)/, '$1.$2');
    value = value.replace(/(\d{21})(\d)/, '$1 $2');
    value = value.replace(/(\d{15})(\d)/, '$1.$2');
    value = value.replace(/(\d{10})(\d)/, '$1 $2');
    value = value.replace(/(\d{5})(\d)/, '$1.$2');
  } else {
    value = value.replace(/(\d{12})(\d)/, '$1 $2');
    value = value.replace(/(\d{11})(\d)/, '$1-$2');
    value = value.replace(/(\d{12})(\d)/, '$1 $2');
    value = value.replace(/(\d{11})(\d)/, '$1-$2');
    value = value.replace(/(\d{12})(\d)/, '$1 $2');
    value = value.replace(/(\d{11})(\d)/, '$1-$2');
    value = value.replace(/(\d{12})(\d)/, '$1 $2');
    value = value.replace(/(\d{11})(\d)/, '$1-$2');
  }
  return value;
};